import React from 'react';
import { CardHeader } from 'reactstrap';
import { CardHeaderSpanType } from '../../Types/CommonComponentType';
import { H3, H4 } from '../../AbstractElements';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'react-feather';
import FeatherIconCom from './CommonIcons/FeatherIconCom';

export default function CardHeaderSpan({
    headingClassName,
    smallHeading,
    heading,
    span,
    span2,
    bigHeadingClassName,
    back = false,
}: CardHeaderSpanType & { back?: boolean }) {
    const navigate = useNavigate();

    return (
        <CardHeader
            className={headingClassName || ''}
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
               
                    {back &&  <button
                        onClick={() => navigate(-1)}
                        style={{
                            alignItems: 'center',
                            border: 'none',
                            borderRadius: '6px',
                            padding: '6px 10px',
                            fontSize: '14px',
                            fontWeight: 500,
                            cursor: 'pointer',
                        }}
                        className='bg-primary'
                    >
                       <FeatherIconCom iconName={"ArrowLeft"} size={20} className="text-light"  />     
                    </button>}
                        {smallHeading ? (
                            <H4 className="mb-0">{smallHeading}</H4>
                        ) : (
                            <H3 className={bigHeadingClassName || 'mb-0'}>{heading}</H3>
                        )}
              


            </div>
        </CardHeader>
    );
}
